import styled from 'styled-components';

export const StyledTitle = styled.h3`
  margin-bottom: 15px;
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  
  & > div {
    position: relative;
    cursor: pointer;
    width: 45%;
  }
  
  & > div:not(:last-child) {
    margin-bottom: 5%;
  }
`;
